export default __webpack_public_path__ + "static/media/icon-wallet.5b677892.svg";